import { useCentralizedProviderData } from '@crehana/auth';
import { useFeatureFlag } from '@crehana/feature-flags/react';

export const useNewPositioningWidgetsFeature = () => {
  const { flagValue, loading: loadingDynamicPositioningWidgets } =
    useFeatureFlag('DYNAMIC_POSITIONING_WIDGETS_UNIFIED_HOME');
  const { me: centralizedMe, loading: loadingCentralizedMe } =
    useCentralizedProviderData();

  const isOrganizationCentralized =
    !!centralizedMe?.security.centralizedSession.centralizedOrganizationId;
  const isNewPositioningWidgetsEnabled = flagValue && isOrganizationCentralized;
  const isLoading = loadingDynamicPositioningWidgets || loadingCentralizedMe;

  return {
    isLoading,
    isNewPositioningWidgetsEnabled,
  };
};
